import { ViewTransition } from 'react';

import { Controls } from './controls';
import { Docs } from './docs';
import { Experiments } from './experiments';
import css from './flags.module.scss';
import type { DataFile, Flag } from './types';
import { parseFlags } from './utils';

interface Props {
    dataFile: DataFile;
}
export function Flags({ dataFile }: Props) {
    const experiments: Flag[] = Object.values(parseFlags(dataFile));

    return (
        <ViewTransition name="container">
            <div className={css.wrapper}>
                <Controls flags={experiments} />
                <Experiments flags={experiments} />
                <Docs />
            </div>
        </ViewTransition>
    );
}
